import React from "react";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";

//components:
import Autocomplete from "@material-ui/lab/Autocomplete";
import {TextField} from "@material-ui/core";

const TrackSelector = ({t, disabledTrackSelector, selectedTrack, setSelectedTrack}) => {
    const loadedTracks = useSelector(state => state.tracks.normalTracks);

    return (
        <div className="w-100 position-relative">
            <label className="form-label flex-row justify-content-start">
                {t("ADMINPANEL.UPLOAD.TRACK_SELECTOR.LABEL")}
                <Link className="ml-2" to={"/adminpanel/tracks"}>
                    {t("ADMINPANEL.TRACKS_MANAGEMENT")}
                </Link>
            </label>
            <div className="autocompleteGroupUpload">
                <Autocomplete
                    options={loadedTracks}
                    defaultValue={selectedTrack}
                    filterSelectedOptions
                    freeSolo
                    blurOnSelect
                    disabled={disabledTrackSelector}
                    getOptionLabel={option => (option && option.name) || ""}
                    onChange={(e, value) => setSelectedTrack(value)}
                    renderInput={(params, i) => (
                        <TextField
                            {...params}
                            autoFocus
                            value={(selectedTrack && selectedTrack.name) || ""}
                            key={i}
                            className="py-2 overflow-hidden w-100 d-flex justify-content-between align-items-center"
                            variant="outlined"
                            label=""
                            type="text"
                            placeholder={t("ADMINPANEL.UPLOAD.SELECT_TRACK")}
                        />
                    )}
                />
            </div>
        </div>
    );
};

export default TrackSelector;
